export default __webpack_public_path__ + "static/platzhalter-video-66747f799de8db889a7c77808edc929f.jpg";